import script from "./Ebooks.vue?vue&type=script&setup=true&lang=js"
export * from "./Ebooks.vue?vue&type=script&setup=true&lang=js"

import "./Ebooks.vue?vue&type=style&index=0&id=0c7706ea&lang=scss"

const __exports__ = script;

export default __exports__